(() => {
if (customElements.get('qwink-colour-gallery')) return;
class QwinkColourGallery extends HTMLElement {
 connectedCallback() {
  this.abort?.abort();
  this.abort = new AbortController();
  this.scope = this.closest('.shopify-section') || this.parentElement;
  this.variants = JSON.parse(this.querySelector('[data-qw-variants]').textContent);
  this.colourPosition = Number(this.dataset.colourPosition);
  this.panels = [...this.querySelectorAll('[data-qw-panel]')];
  this.index = 0;
  this.colour = this.dataset.initialColour;
  const listen = (target, type, fn) => target.addEventListener(type, fn, {signal:this.abort.signal});
  listen(this, 'click', event => {
   const button = event.target.closest('button');
   if (!button || !this.contains(button)) return;
   if (button.hasAttribute('data-qw-index')) this.show(Number(button.dataset.qwIndex));
   if (button.hasAttribute('data-qw-prev')) this.show(this.index - 1);
   if (button.hasAttribute('data-qw-next')) this.show(this.index + 1);
   if (button.hasAttribute('data-qw-zoom')) {
    const dialog = this.querySelector('dialog');
    const main = this.activePanel().querySelector('[data-qw-main]');
    const zoom = dialog.querySelector('img');
    zoom.src = main.dataset.fullSrc || main.src;
    zoom.alt = main.alt;
    dialog.showModal();
   }
   if (button.hasAttribute('data-qw-close')) this.querySelector('dialog').close();
  });
  listen(this, 'keydown', e => {
   if (e.target.closest('dialog')) return;
   if (e.key === 'ArrowRight') {e.preventDefault();this.show(this.index + 1);}
   if (e.key === 'ArrowLeft') {e.preventDefault();this.show(this.index - 1);}
  });
  listen(this.scope, 'change', e => {
   const field=e.target;
   if (Number(field.dataset.optionPosition) === this.colourPosition) this.setColour(field.value);
   else if (field.name === 'id') this.setVariant(field.value);
   else this.readSelection();
  });
  listen(document, 'simple-variant-picker:variantChange', e => this.setVariant(e.detail?.variant?.id));
  listen(document, 'variant:change', e => this.setVariant(e.detail?.variant?.id));
  listen(document, 'simple-variant-picker:optionChange', e => {
   if(Number(e.detail?.position)===this.colourPosition) this.readSelection();
  });
  listen(window,'popstate',() => {
   const id=new URLSearchParams(location.search).get('variant');
   if(id) this.setVariant(id); else this.readSelection();
  });
  let start=null;
  listen(this, 'pointerdown',e=>{if(e.pointerType==='touch'&&e.target.closest('[data-qw-stage]')) start={x:e.clientX,y:e.clientY};});
  listen(this, 'pointerup',e=>{
   if(!start) return;
   const dx=e.clientX-start.x,dy=e.clientY-start.y;
   start=null;
   if(Math.abs(dx)>50&&Math.abs(dx)>Math.abs(dy)*1.5) this.show(this.index+(dx<0?1:-1));
  });
  listen(this,'pointercancel',()=>{start=null;});
  this.setColour(this.colour);
  this.readSelection();
 }
 disconnectedCallback(){this.abort?.abort();}
 normalise(value){return String(value||'').toLowerCase().replace('gray','grey');}
 activePanel(){return this.panels.find(p=>p.dataset.qwPanel===this.colour)||this.panels[0];}
 setVariant(id){
  const variant=this.variants.find(v=>String(v.id)===String(id).split('/').pop());
  if(variant)this.setColour(variant.colour);
 }
 readSelection(){
  const p=this.colourPosition;
  const field=this.scope.querySelector('qwink-pad-bundles [data-option="'+(p-1)+'"],input[data-option-position="'+p+'"]:checked,select[data-option-position="'+p+'"]');
  if(field)this.setColour(field.value);
 }
 setColour(value){
  const colour=this.normalise(value);
  if(!this.panels.some(p=>p.dataset.qwPanel===colour))return;
  this.colour=colour;
  this.panels.forEach(p=>{p.hidden=p.dataset.qwPanel!==colour;});
  this.show(this.index);
 }
 show(index){
  const panel=this.activePanel(); if(!panel)return;
  const thumbs=[...panel.querySelectorAll('[data-qw-index]')];
  if(!thumbs.length)return;
  this.index=(index+thumbs.length)%thumbs.length;
  const selected=thumbs[this.index], main=panel.querySelector('[data-qw-main]');
  if(main.dataset.fullSrc!==selected.dataset.qwSrc){
   main.src=selected.dataset.qwSrc+(selected.dataset.qwSrc.includes('?')?'&':'?')+'width=1100';
   main.srcset=[550,1100,1600].map(w=>selected.dataset.qwSrc+(selected.dataset.qwSrc.includes('?')?'&':'?')+'width='+w+' '+w+'w').join(', ');
   main.dataset.fullSrc=selected.dataset.qwSrc;
   main.alt=selected.dataset.qwAlt;
  }
  thumbs.forEach((b,i)=>b.setAttribute('aria-pressed',String(i===this.index)));
  this.querySelector('[data-qw-status]').textContent=this.colour.charAt(0).toUpperCase()+this.colour.slice(1)+' · Image '+(this.index+1)+' of '+thumbs.length;
 }
}
customElements.define('qwink-colour-gallery',QwinkColourGallery);
})();